// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rP1u","clinicsSelect":"styles_clinicsSelect__1cuk6"};